module.exports = __webpack_public_path__ + "img/rsz_20221029_borito.456145f1.jpg";